import { useState } from "react";

import { colorsPalettes } from "@similarweb/styles";
import { Button, IconButton, Modal } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { useTranslation } from "pro-features/components/WithTranslation";

interface IShareDialogProps {
    isOpen: boolean;
    onClose: () => void;
    shareLink: string;
    contentText?: string;
}

export const ShareDialog = ({ isOpen, onClose, shareLink, contentText }: IShareDialogProps) => {
    const [isCopied, setIsCopied] = useState(false);
    const translate = useTranslation();

    const handleCopyLink = async () => {
        try {
            await navigator.clipboard.writeText(shareLink);
            setIsCopied(true);
            setTimeout(() => setIsCopied(false), 2000);
        } catch (error) {
            console.error("Failed to copy link:", error);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            customStyles={{ content: { width: "400px" } }}
        >
            <Modal.Header>
                <Modal.Title>{translate("monitor_and_protect.shared.share_dialog.title")}</Modal.Title>
            </Modal.Header>
            <Modal.Content padding="24px">
                <Text
                    fontVariant="body1"
                    color={colorsPalettes.carbon["400"]}
                >
                    {contentText || translate("monitor_and_protect.shared.share_dialog.default_content")}
                </Text>
            </Modal.Content>
            <Modal.Footer>
                <Flex
                    justifyContent="space-between"
                    alignItems="center"
                    width="100%"
                >
                    <Button
                        type="flat"
                        onClick={onClose}
                    >
                        {translate("monitor_and_protect.shared.share_dialog.done_button")}
                    </Button>
                    <IconButton
                        iconName="organic-link"
                        type="primary"
                        onClick={() => void handleCopyLink()}
                    >
                        {isCopied
                            ? translate("monitor_and_protect.shared.share_dialog.link_copied")
                            : translate("monitor_and_protect.shared.share_dialog.copy_link")}
                    </IconButton>
                </Flex>
            </Modal.Footer>
        </Modal>
    );
};
